module.exports = {
  transpileDependencies: [
    'vuetify'
  ],
  devServer: {
    allowedHosts: ['.develop.bankalliance.ua', '.bankalliance.ua']
  },
  publicPath: process.env.VUE_APP_PATH
}
